import React, { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { motion } from "framer-motion";
import { serviceCategories } from "./serviceCategories";

const ServicesPage = () => {
  const { slug } = useParams();

  const category = serviceCategories.find((cat) =>
    cat.services.some((srv) => srv.url.endsWith(slug))
  );

  const service = category
    ? category.services.find((srv) => srv.url.endsWith(slug))
    : null;

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [slug]);

  if (!service) {
    return (
      <div className="text-center pt-40 min-h-[60vh]">
        <h1 className="text-4xl font-bold text-red-600">
          Servicio no encontrado
        </h1>
        <Link
          to="/#services"
          className="mt-6 inline-block px-6 py-3 bg-green-600 text-white rounded-full hover:bg-green-700 transition"
        >
          Volver a Servicios
        </Link>
      </div>
    );
  }

  // Extraer todos los videos e imágenes
  const mediaItems = Object.entries(service)
    .filter(
      ([key, value]) =>
        value &&
        (key.toLowerCase().includes("video") ||
          key.toLowerCase().includes("image") ||
          key.toLowerCase().includes("img"))
    )
    .map(([key, value]) => ({ key, value }));

  // Componente para cada media (video o imagen)
  const ResponsiveMedia = ({ src, isVideo }) => (
    <div
      className="relative rounded-2xl overflow-hidden shadow-lg flex items-center justify-center bg-white"
      style={{
        aspectRatio: "4/3",
        width: "100%",
        minHeight: "200px",
      }}
    >
      {isVideo ? (
        <video
          src={src}
          controls
          playsInline
          controlsList="nodownload"
          onContextMenu={(e) => e.preventDefault()}
          className="absolute top-0 left-0 w-full h-full object-contain"
        />
      ) : (
        <img
          src={src}
          alt="media"
          className="absolute top-0 left-0 w-full h-full object-contain cursor-zoom-in"
          onClick={(e) => {
            const img = e.currentTarget;
            if (img.requestFullscreen) img.requestFullscreen();
            else if (img.webkitRequestFullscreen) img.webkitRequestFullscreen();
          }}
        />
      )}
    </div>
  );

  // Grid para desktop
  const getDesktopGrid = (count) => (count <= 3 ? "lg:grid-cols-3" : "lg:grid-cols-2");

  return (
    <section className="pb-20 bg-gradient-to-br from-green-50 to-emerald-50 flex flex-col items-center justify-start px-4 pt-16">
      <div className="container mx-auto text-center max-w-6xl">
        {/* Título */}
        <motion.h1
          className="text-4xl md:text-5xl font-bold text-green-700 mb-10"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          {service.name}
        </motion.h1>

        {/* Grid de medios */}
        {mediaItems.length > 0 && (
          <div
            className={`grid grid-cols-1 sm:grid-cols-1 md:grid-cols-1 ${getDesktopGrid(
              mediaItems.length
            )} gap-6 w-full max-w-7xl mx-auto mb-12`}
          >
            {mediaItems.map((item, index) => (
              <ResponsiveMedia
                key={index}
                src={item.value}
                isVideo={item.key.toLowerCase().includes("video")}
              />
            ))}
          </div>
        )}

        {/* Descripción */}
        <div
          className="text-lg text-gray-700 mb-10 leading-relaxed px-4 md:px-10"
          dangerouslySetInnerHTML={{
            __html:
              service.description ||
              "Próximamente más información sobre este tratamiento.",
          }}
        />

        {/* WhatsApp */}
        <motion.a
          href={`https://wa.me/573237076868?text=Hola!%20Quiero%20agendar%20una%20cita%20para%20el%20servicio%20de%20${encodeURIComponent(
            service.name
          )}`}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-block px-8 py-3 bg-green-600 text-white rounded-full font-semibold shadow hover:bg-green-700 transition"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0.4 }}
        >
          Agenda tu cita
        </motion.a>

        {/* Volver */}
        <div className="mt-10">
          <Link
            to="/#services"
            className="inline-block px-6 py-3 bg-green-600 text-white rounded-full hover:bg-green-700 transition"
          >
            Volver a Servicios
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ServicesPage;

























